import CloseIcon from '@mui/icons-material/Close';
import React from 'react';

import { Button } from '../Button/Button';
import { IconButton } from '../IconButton/IconButton';

interface SnackbarActionsProps {
  onUndo?: () => void;
  onClose?: () => void;
}

export const SnackbarActions = (props: SnackbarActionsProps) => {
  const { onUndo, onClose } = props;

  return (
    <>
      {onUndo && (
        <Button
          color='secondary'
          text='UNDO'
          onClick={() => {
            onUndo();
          }}
        />
      )}
      {onClose && (
        <IconButton
          size='small'
          aria-label='close'
          color='inherit'
          onClick={() => {
            onClose();
          }}>
          <CloseIcon fontSize='small' />
        </IconButton>
      )}
    </>
  );
};
